import { render, staticRenderFns } from "./restrict.vue?vue&type=template&id=039497e4&"
import script from "./restrict.vue?vue&type=script&lang=js&"
export * from "./restrict.vue?vue&type=script&lang=js&"
import style0 from "./restrict.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports